export const formatStorageValue = <T>(val: T) => {
  try {
    return JSON.parse(val as any);
  } catch (_) {
    return val;
  }
};

export const getStorageItem = <T>(key: string) =>
  formatStorageValue<T>(localStorage.getItem(key) as T);

export const setStorageItem = <T>(key: string, valueToStore: T) =>
  localStorage.setItem(
    key,
    typeof valueToStore === 'string' // If the value is a string, we don't need to stringify it
      ? valueToStore
      : JSON.stringify(valueToStore)
  );

export const removeStorageItem = (key: string) => localStorage.removeItem(key);
